export const eddiebauers = [
  { image: "/images/eddiebauer/1.jpg" },
  { image: "/images/eddiebauer/2.jpg" },
  { image: "/images/eddiebauer/3.jpg" },
];
